import axios from 'axios'

export const state = {
  shifts: null,
  replacements: null,
  shiftsAlert: null,
}

export const getters = {
  shifts: (state) => state.shifts,
  shiftOptions: (state) =>
    state.shifts && state.shifts.map(({ id, title }) => ({ id, label: title })),
  shiftsAlert: (state) => state.shiftsAlert,
  replacements: (state) => state.replacements,
}

export const mutations = {
  SET_SHIFTS(state, shifts) {
    state.shifts = shifts
  },

  SET_ALERT(state, alert) {
    state.shiftsAlert = alert
  },

  SET_REPLACEMENTS(state, replacements) {
    state.replacements = replacements
  },
}

export const actions = {
  fetchAllShifts({ commit, state, rootState }, payload) {
    return axios.get('/api/shifts', { params: payload }).then((response) => {
      commit('SET_SHIFTS', response.data.shifts)
      commit('SET_ALERT', response.data.alert)
      commit('SET_REPLACEMENTS', response.data.replacements)
      return response.data
    })
  },
}
